<template>
  <div class="row token-info">
    <div class="col-6 col-md-4">
      <span class="label">N&uacute;mero de Propuesta:</span>
      <span class="info">
        {{ value.proposalNumber }}
      </span>
    </div>
    <div class="col-6 col-md-4">
      <span class="label">C&oacute;digo de Evaluaci&oacute;n:</span>
      <span class="info">
        {{ value.token }}
      </span>
    </div>
    <div class="col-6 col-md-4">
      <span class="label">Evaluador:</span>
      <span class="info">
        {{ value.evaluator }}
      </span>
    </div>
    <div class="w-100 separator  d-md-block" />
    <div class="col-6 col-md-4">
      <span class="label">Fecha Solicitado:</span>
      <span class="info">
        {{ value.date | date }}
      </span>
    </div>
    <div class="col-6 col-md-4">
      <span class="label">Tiempo de Expiraci&oacute;n:</span>
      <span class="info">
        {{ value.expirationDate | date }}
        <b>{{ value.expirationDate | hour }}</b>
      </span>
    </div>
    <div class="col-6 col-md-4">
      <span class="label">Lugar:</span>
      <span class="info">
        {{ value.place }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenHistoryResult',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.token-info {
  background-color: map-get($colors, 'secondary-3');
  border-radius: 0.25rem;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;

  .label {
    display: block;
    font-size: 0.875rem;
    color: map-get($colors, 'secondary-6');
  }
  .info {
    color: map-get($colors, 'black');
  }

  .separator {
    border-bottom: 1px solid#DEDEDE;
    margin: 1rem 0rem;
  }
}
</style>
